export function deepCloneObj (obj) {
  return JSON.parse(JSON.stringify(obj))
}
